import {z} from 'zod';
import {ApiDefinition} from '../definitions';
import {ObjectIdSchema} from '../../zod';

export const RecommendedAccountsImport = {
  path: 'recommendedAccountsImport',
  method: 'post',
  options: {access: 'paid'},
  requestDataSchema: z.object({
    cloudStorageBucket: z.string(),
    cloudStorageFilePath: z.string(),
    source: z.string(),
    tagId: ObjectIdSchema,
  }),
  responseDataSchema: z.object({
    taskId: z.string(),
  }),
} satisfies ApiDefinition;

export const UploadUrl = {
  path: 'uploadUrl',
  method: 'post',
  options: {access: 'paid'},
  requestDataSchema: z.object({
    contentSize: z.number(),
  }),
  responseDataSchema: z.object({
    cloudStorageBucket: z.string(),
    cloudStorageFilePath: z.string(),
    url: z.string(),
  }),
} satisfies ApiDefinition;

export const FileCrmImport = {
  path: 'fileCRMImport',
  method: 'post',
  options: {access: 'paid'},
  requestDataSchema: z.object({
    cloudStorageBucket: z.string(),
    cloudStorageFilePath: z.string(),
  }),
  responseDataSchema: z.object({
    taskId: z.string().optional(),
  }),
} satisfies ApiDefinition;
